import React from 'react';
import { isMobile } from 'react-device-detect';
import PuzzleTopBar from '../shared/PuzzleTopBar';
import { PuzzleNames } from '../../../utils/types';
import { PathwordStore } from './PathwordStore';
import { onReveal, onSolve, savePathword } from './pathwordUtils';
import Instructions from './components/Instructions';
import PathwordGrid from './components/PathwordGrid';
import { useAmplitudeTracking, useFirstTimeInstructions, useIsMobileDimensions, usePageVisibilityPause, useStructuredDataEmbedding } from '../shared/utils';
import PauseCover from '../shared/PauseCover';
import MobilePathwordInstructions from './components/MobileInstructions';
import AlmostThereDialog from './components/AlmostThereDialog';
import { usePuzzleTracking } from '../../../utils/usePuzzleTracking';

const Pathword = () => {
  useFirstTimeInstructions(PuzzleNames.Pathword, PathwordStore as any);
  usePageVisibilityPause(PathwordStore as any, savePathword);
  useStructuredDataEmbedding(PuzzleNames.Pathword);
  useAmplitudeTracking(PuzzleNames.Pathword);
  usePuzzleTracking(PuzzleNames.Pathword);

  const useMobileStyles = isMobile || useIsMobileDimensions();

  return (
    <>
      <PuzzleTopBar
        puzzleName={PuzzleNames.Pathword}
        store={PathwordStore as any}
        onReveal={onReveal}
        onSave={savePathword}
        InstructionsComponent={useMobileStyles ? MobilePathwordInstructions : Instructions}
      />
      <AlmostThereDialog/>
      <div className="puzzleContainer pathwordContainer">
        <PathwordGrid store={PathwordStore} onSolve={onSolve}/>
        <PauseCover store={PathwordStore as any}/>
      </div>
    </>
  )
};

export default Pathword;